export default __webpack_public_path__ + "static/office-72c3330a1dac588f4bb79858e47b1e5c.jpg";